const parallax = document.querySelectorAll('.jarallax');

jarallax(parallax, {
  type: 'scroll'
});